import { HaftpflichtSchaden } from '@gsm/entities';
import { TYPE_HAFTPFLICHT_GESCHAEDIGTE_PERSON } from '../haftpflicht-geschaedigte-person/haftpflicht-geschaedigte-person.model';
import { AnyFormControlModel } from '../shared-models/any-form-control.model';
import { HaftpflichtAdditional } from '../shared-models/haftpflichtschaden.model';

export function HAFTPFLICHT_SACHSCHADEN_KABEL_LEITUNG_TEMPLATE(
  value: HaftpflichtSchaden,
  modelValue,
  {
    geschPersList,
    updateClaim,
    paperProcessOverride
  }: HaftpflichtAdditional = {},
  isEditEvent = false
): AnyFormControlModel[] {
  const {
    id,
    vorhanden,
    geschaedigtePerson
  } = value || {};

  if (!isEditEvent && geschPersList && modelValue.length) {
    // only persons who are not in the local modelValue
    geschPersList = geschPersList.filter(
      geschPers => !modelValue.some(val => val.geschaedigtePerson?.correlationId === geschPers.correlationId)
    );
  }

  return [
    {
      id:         'geschaedigtePerson',
      type:       TYPE_HAFTPFLICHT_GESCHAEDIGTE_PERSON,
      value:      {
        id,
        vorhanden,
        geschaedigtePerson
      },
      additional: {
        geschPersList,
        updateClaim,
        paperProcessOverride,
        detailsNachbringen: false
      }
    }
  ];
}
